"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var braintree_web_1 = __importDefault(require("braintree-web"));
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var payment_1 = require("../steps/payment");
var error_message_1 = __importDefault(require("./error_message"));
var useContext = react_1.default.useContext, useState = react_1.default.useState, useEffect = react_1.default.useEffect;
exports.default = (function () {
    var context = useContext(app_1.CheckoutContext);
    var paymentContext = useContext(payment_1.PaymentContext);
    if (!context || !paymentContext)
        return null;
    var paymentAuthorizationToken = context.paymentAuthorizationToken, email = context.email, setPaymentValid = context.setPaymentValid;
    var setCCTokenizer = paymentContext.setCCTokenizer, setCardType = paymentContext.setCardType;
    var _a = __read(useState(null), 2), ccNumberError = _a[0], setCCNumberError = _a[1];
    var _b = __read(useState(null), 2), ccExpiryError = _b[0], setCCExpiryError = _b[1];
    var _c = __read(useState(null), 2), ccCVCError = _c[0], setCVCError = _c[1];
    var braintreeHostedFieldsInstance;
    var onFieldValidityChange = function (event) {
        if (event.fields.number && !event.fields.number.isEmpty && !event.fields.number.isValid)
            setCCNumberError('Card Number is not valid');
        else
            setCCNumberError(null);
        if (event.fields.expirationDate && !event.fields.expirationDate.isEmpty && !event.fields.expirationDate.isValid)
            setCCExpiryError('Expiry Date is not valid');
        else
            setCCExpiryError(null);
        if (event.fields.cvv && !event.fields.cvv.isEmpty && !event.fields.cvv.isValid)
            setCVCError('CVV is not valid');
        else
            setCVCError(null);
        if (!event.fields.cvv.isEmpty &&
            !event.fields.expirationDate.isEmpty &&
            !event.fields.number.isEmpty &&
            event.fields.number.isValid &&
            event.fields.expirationDate.isValid &&
            event.fields.cvv.isValid) {
            setPaymentValid(true);
        }
        else {
            setPaymentValid(false);
        }
    };
    var onCardTypeChange = function (event) {
        if (event.cards.length === 1) {
            var cardType = void 0;
            switch (event.cards[0].type) {
                case 'american-express':
                    cardType = 'amex';
                    break;
                case 'discover':
                    cardType = 'discover';
                    break;
                case 'master-card':
                case 'maestro':
                    cardType = 'masterCard';
                    break;
                case 'visa':
                    cardType = 'visa';
                    break;
                default:
                    cardType = undefined;
            }
            setCardType(cardType);
        }
        else {
            setCardType(undefined);
        }
    };
    var tokenizeBraintree = function (bAddress) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //  bAddress is taken in as a parameter and not through the context.
            // The way the tokenizer is dynamically set up, billing address is not available in the execution scope.
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    braintreeHostedFieldsInstance.tokenize({
                        cardholderName: "".concat(bAddress === null || bAddress === void 0 ? void 0 : bAddress.firstName, " ").concat(bAddress === null || bAddress === void 0 ? void 0 : bAddress.lastName),
                        billingAddress: {
                            email: email,
                            firstName: bAddress === null || bAddress === void 0 ? void 0 : bAddress.firstName,
                            lastName: bAddress === null || bAddress === void 0 ? void 0 : bAddress.lastName,
                            postalCode: bAddress === null || bAddress === void 0 ? void 0 : bAddress.zip,
                            company: bAddress === null || bAddress === void 0 ? void 0 : bAddress.company,
                            streetAddress: bAddress === null || bAddress === void 0 ? void 0 : bAddress.address1,
                            extendedAddress: bAddress === null || bAddress === void 0 ? void 0 : bAddress.address2,
                            locality: bAddress === null || bAddress === void 0 ? void 0 : bAddress.city,
                            region: bAddress === null || bAddress === void 0 ? void 0 : bAddress.state,
                            countryName: bAddress === null || bAddress === void 0 ? void 0 : bAddress.country,
                        },
                    }, function (err, data) {
                        if (err)
                            return reject(err);
                        if (!data)
                            return;
                        return resolve({
                            token: data.nonce,
                            cardType: data.details.cardType,
                            expiry: "".concat(data.details.expirationMonth, "/").concat(data.details.expirationYear),
                            last4: data.details.lastFour,
                        });
                    });
                })];
        });
    }); };
    var onClientInstanceReady = function (clientInstance) {
        braintree_web_1.default.hostedFields
            .create({
            client: clientInstance,
            styles: {
                input: {
                    'font-size': '16px',
                    'font-family': '"Oakes Grotesk", sans-serif',
                    'font-weight': 'lighter',
                    border: 'none',
                },
                ':focus': {
                    outline: 'none',
                    border: '1px solid #a76bbb',
                },
            },
            fields: {
                number: {
                    selector: '#bt-hosted-field-number',
                },
                cvv: {
                    selector: '#bt-hosted-field-cvv',
                },
                expirationDate: {
                    selector: '#bt-hosted-field-expiry-date',
                },
            },
        })
            .catch(function (reason) {
            console.error('creating braintree fields failed with', reason);
            throw new Error("creating braintree fields failed with ".concat(reason));
        })
            .then(function (instance) {
            if (instance) {
                braintreeHostedFieldsInstance = instance;
                setCCTokenizer(function () { return tokenizeBraintree; });
                braintreeHostedFieldsInstance.on('validityChange', onFieldValidityChange);
                braintreeHostedFieldsInstance.on('cardTypeChange', onCardTypeChange);
            }
        });
    };
    useEffect(function () {
        braintree_web_1.default.client
            .create({ authorization: paymentAuthorizationToken })
            .then(function (clientInstance) {
            onClientInstanceReady(clientInstance);
        })
            .catch(function (reason) {
            console.error('Error creating Braintree client instance', reason);
            return;
        });
        return;
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'checkout-card-field-container' },
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field cc-number', id: 'bt-hosted-field-number' }),
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field-label' }, "Card Number"),
            react_1.default.createElement(error_message_1.default, { error: { message: ccNumberError || '' } })),
        react_1.default.createElement("div", { className: 'checkout-card-field-container' },
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field', id: 'bt-hosted-field-expiry-date' }),
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field-label' }, "Expiry Date (Month/Year)"),
            react_1.default.createElement(error_message_1.default, { error: { message: ccExpiryError || '' } })),
        react_1.default.createElement("div", { className: 'checkout-card-field-container' },
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field', id: 'bt-hosted-field-cvv' }),
            react_1.default.createElement("div", { className: 'checkout-hosted-payment-field-label' }, "CVV"),
            react_1.default.createElement(error_message_1.default, { error: { message: ccCVCError || '' } }))));
});
